import React from 'react';

const APP_STORE_URL = 'https://apps.apple.com/app/id1474559034';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.fidelize';

const BRAND = '#3b95e8';
const MUTED = 'rgba(232,240,254,0.45)';
const CARD_BORDER = 'rgba(255,255,255,0.10)';

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="white">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26">
    <path fill="#EA4335" d="M3.18 23.76c.3.16.64.18.96.07l11.5-6.64-2.59-2.6z" />
    <path fill="#FBBC05" d="M21.37 9.46l-3.01-1.74-2.87 2.56 2.87 2.87 3.03-1.75c.86-.5.86-1.44-.02-1.94z" />
    <path fill="#4285F4" d="M3.18.24C2.83.06 2.42.1 2.1.37L13.43 12 16.02 9.4z" />
    <path fill="#34A853" d="M2.1 23.63c.32.27.73.31 1.08.13l12.84-7.57-2.59-2.59z" />
  </svg>
);

const StoreBtn = ({ href, icon, label, sub }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: 'flex', alignItems: 'center', gap: 14,
      padding: '14px 24px',
      background: 'rgba(255,255,255,0.06)',
      border: `1px solid ${CARD_BORDER}`,
      borderRadius: 16,
      minWidth: 190,
      textDecoration: 'none',
      transition: 'background 0.15s, border-color 0.15s',
    }}
    onMouseEnter={e => {
      e.currentTarget.style.background = 'rgba(59,149,232,0.12)';
      e.currentTarget.style.borderColor = 'rgba(59,149,232,0.4)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
      e.currentTarget.style.borderColor = CARD_BORDER;
    }}
  >
    {icon}
    <div>
      <div style={{ fontSize: 11, color: MUTED, lineHeight: 1, marginBottom: 3 }}>{sub}</div>
      <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', lineHeight: 1 }}>{label}</div>
    </div>
  </a>
);

const Download = () => (
  <>
    <style>{`html, body { margin: 0; padding: 0; }`}</style>
    <main style={{
      background: 'linear-gradient(160deg, #0a1628 0%, #0f1f3d 50%, #0a1628 100%)',
      minHeight: '100vh',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '60px 24px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      boxSizing: 'border-box',
      position: 'relative',
    }}>

      {/* Background glow */}
      <div style={{
        position: 'absolute', top: '40%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(59,149,232,0.10) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      {/* Logo */}
      <div style={{
        fontFamily: 'FingerPaint, serif',
        fontSize: 72, color: '#fff',
        lineHeight: 1, marginBottom: 8,
      }}>f</div>

      <div style={{
        fontSize: 12, fontWeight: 700, letterSpacing: 3,
        color: BRAND, textTransform: 'uppercase', marginBottom: 16,
      }}>Fidelize</div>

      <h1 style={{
        fontSize: 'clamp(22px, 4vw, 36px)',
        fontWeight: 800, color: '#fff',
        margin: '0 0 10px', letterSpacing: -0.5,
        textAlign: 'center',
      }}>
        Descarga la app
      </h1>

      <p style={{
        fontSize: 15, color: MUTED,
        textAlign: 'center', margin: '0 0 48px',
        maxWidth: 300, lineHeight: 1.6,
      }}>
        Acumula puntos, canjea regalos y mantente conectado con tus comercios favoritos.
      </p>

      {/* Store buttons */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 52, alignItems: 'center' }}>
        <StoreBtn
          href={APP_STORE_URL}
          icon={<AppleIcon />}
          sub="Descargar en el"
          label="App Store"
        />
        <StoreBtn
          href={PLAY_STORE_URL}
          icon={<PlayIcon />}
          sub="Disponible en"
          label="Google Play"
        />
      </div>

      {/* Platform badges */}
      <div style={{
        display: 'flex', gap: 32,
        borderTop: `1px solid rgba(255,255,255,0.07)`,
        paddingTop: 32, marginBottom: 40,
      }}>
        {[
          { value: 'iOS', label: 'App Store' },
          { value: 'Android', label: 'Google Play' },
        ].map(({ value, label }) => (
          <div key={value} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: BRAND, marginBottom: 4 }}>{value}</div>
            <div style={{ fontSize: 11, color: MUTED }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Footer links */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 12 }}>
        <a href="/terms/es" style={{ fontSize: 12, color: MUTED, textDecoration: 'none' }}>Términos de uso</a>
        <span style={{ color: 'rgba(255,255,255,0.15)', fontSize: 12 }}>·</span>
        <a href="/privacy/es" style={{ fontSize: 12, color: MUTED, textDecoration: 'none' }}>Privacidad</a>
      </div>
      <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.15)', margin: 0 }}>
        © {new Date().getFullYear()} Alpes Solutions · fidelize.org
      </p>
    </main>
  </>
);

export default Download;
